import { useState, useCallback } from 'react';
import { v4 } from 'uuid';
import { useChangeEffect } from '@utils/react';
import { makeComponentEntryEnvelopeFromComponentEnvelope } from '../util.make-component-entry-envelope.js';
import { useMutateEntry } from './hook.mutate-entry.js';

let resetCounter = 0;
function useEntryKey(args) {
  const [entryKey, setEntryKey] = useState(() => args.defaultEntryKey ?? v4());
  const updateEntry = useMutateEntry(entryKey);
  useChangeEffect(() => {
    if (args.defaultEntryKey) {
      setEntryKey(args.defaultEntryKey);
    }
  }, [args.defaultEntryKey]);
  const onResetEntry = useCallback(initialState => {
    const nextEntryKey = args.parentOnResetEntry?.(initialState) ?? `new-entry.${args.componentEnvelope.ID}.${resetCounter++}`;
    const entryData = args.schema.parse(initialState ?? {});
    updateEntry(previousEntry => ({
      learningObject: previousEntry.learningObject,
      data: args.postprocessEntry?.(entryData) ?? entryData,
      entryKey: nextEntryKey,
      state: {
        result: "success",
        isMutating: false
      },
      envelope: makeComponentEntryEnvelopeFromComponentEnvelope({
        id: previousEntry?.envelope.userID ?? ""
      }, args.componentEnvelope)
    }));
    setEntryKey(nextEntryKey);
    args.onEntryKeyReset?.(nextEntryKey);
    return nextEntryKey;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [args.componentEnvelope, args.schema, args.onEntryKeyReset, entryKey, updateEntry]);
  return [entryKey, onResetEntry];
}

export { useEntryKey };
//# sourceMappingURL=hook.entry-key.js.map
